<template>
  <transition name="fade">
    <div
      v-if="valorData"
      ref="unimedcomp__menu"
      :style="estiloDinamicoMenu"
      class="unimedcomp__menu"
      @scroll="onScroll"
    >
      <div
        v-for="(item, i) in items"
        v-show="i < limiteItemScrollAtual || (setaIndex && i <= setaIndex)"
        ref="items"
        :key="'caducomp-item-' + i"
        class="unimedcomp__item"
        :class="{
          'unimedcomp__item--selected': selecionaItem(item)
        }"
        @click="noClickSelecionarItem(item, i)"
      >
        <slot :item="item" name="item">
          <span>
            {{ pegarTextoItem(item) }}
          </span>
        </slot>
      </div>
      <div v-if="!items.length" class="unimedcomp__no-data">
        <slot name="no-data"> Nenhum dado disponível </slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  model: {
    prop: 'valor',
    event: 'input'
  },
  props: {
    valor: {
      type: [String, Number, Boolean, Array, Object],
      required: true,
      note:
        'Valor padrão para todos os componentes que precisarem de alguma estrutura de v-model. Recebendo o valor e enviando para o parente.'
    },
    largura: {
      type: [String, Number],
      required: false,
      default: 100,
      note: 'Largura do Menu'
    },
    altura: {
      type: [String, Number],
      required: false,
      default: 150,
      note: 'Altura do Menu.'
    },
    alturaMaximaMenu: {
      type: [String, Number],
      required: false,
      default: 200,
      note: 'Altura máxima dos itens dentro do menu.'
    },
    limiteItemScroll: {
      type: Number,
      default: 20,
      note: 'O número limite inical dos itens no menu.'
    },
    numeroItemAdicionarScroll: {
      type: Number,
      default: 10,
      note: 'Quantidade de itens que são adicionados pelo evento de scroll.'
    },
    items: {
      type: Array,
      default: () => [],
      note: 'Array que contém os itens que serão mostrado em forma de lista.'
    }
  },
  data() {
    return {
      limiteItemScrollAtual: this.limiteItemScroll,
      setaIndex: null,
      itemSelecionadoSeta: null,
      itemSelecionado: null,
      valorData: this.valor
    }
  },
  methods: {
    pegarTextoItem(item) {
      if (!item) return null
      return item
    },
    noClickSelecionarItem(item, i) {
      this.itemSelecionado = item
      this.$emit('input', false)
      this.$emit('index', i)
      this.eventoValor(item)
    },
    selecionaItem(item) {
      return item === this.itemSelecionadoSeta || (item === this.itemSelecionado && !this.itemSelecionadoSeta)
    },
    onScroll(event) {
      if (this.limiteItemScrollAtual >= this.items.length) return

      const content = event.target
      const showMoreItems = content.scrollHeight - (content.scrollTop + content.clientHeight) < 200

      if (showMoreItems) {
        this.limiteItemScrollAtual += this.numeroItemAdicionarScroll
      }
    },
    eventoValor(item) {
      this.itemSelecionadoSeta = null
      this.$nextTick(() => {
        this.$emit('select', item)
      })
    }
  },
  computed: {
    estiloDinamicoMenu() {
      const obj = { width: this.largura + 'px', left: this.altura + 'px', 'max-height': `${this.alturaMaximaMenu}px` }

      return obj
    }
  },
  watch: {
    valor() {
      this.valorData = this.valor
    },
    valorData() {
      this.$emit('input', this.valorData)
    }
  }
}
</script>

<style lang="sass">
.unimedcomp__menu
  overflow: auto
  position: absolute
  left: auto !important
  z-index: 8
  transform-origin: left top 0
  background-color: #fff
  border: 1px solid #ced4da
  border-radius: 8px
  border-top-left-radius: 0
  border-top-right-radius: 0
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)

.unimedcomp__no-data
  text-align: center
  margin: 0 5px

  &.unimedcomp__menu--disable-search
    border-top: 1
    border-top-left-radius: 2px
    border-top-right-radius: 2px

.unimedcomp__item
  text-align: left
  padding-left: 40px
  cursor: pointer
  padding: 4px 12px
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)
  color: #54585e

  &:hover, &.unimedcomp__item--selected
    background-color: #dee2e6
</style>
